import { module as BaseModule } from 'modujs';

export default class extends BaseModule {
	constructor(m) {
		super(m);
	}

	init() {
		const el = this.el;

		// Encontrar el contenedor .swiper dentro del módulo
		const swiperEl = el.querySelector('.swiper');
		if (!swiperEl) return;

		const wrapper = swiperEl.querySelector('.swiper-wrapper');
		if (!wrapper) return;

		// Función que realiza la inicialización real cuando Swiper esté disponible
		const _doInit = () => {
			// Crear paginación/navegación si no existen
			let pagination = swiperEl.querySelector('.swiper-pagination');
			if (!pagination) {
				pagination = document.createElement('div');
				pagination.className = 'swiper-pagination';
				swiperEl.appendChild(pagination);
			}

			let nextBtn = swiperEl.querySelector('.swiper-button-next');
			let prevBtn = swiperEl.querySelector('.swiper-button-prev');
			if (!nextBtn) {
				nextBtn = document.createElement('div');
				nextBtn.className = 'swiper-button-next';
				swiperEl.appendChild(nextBtn);
			}
			if (!prevBtn) {
				prevBtn = document.createElement('div');
				prevBtn.className = 'swiper-button-prev';
				swiperEl.appendChild(prevBtn);
			}

			const options = {
				loop: true,
				slidesPerView: 1,
				spaceBetween: 12,
				pagination: {
					el: pagination,
					clickable: true,
				},
				navigation: {
					nextEl: nextBtn,
					prevEl: prevBtn,
				},
				breakpoints: {
					768: { slidesPerView: 2 },
					1200: { slidesPerView: 3 },
				},
			};

			try {
				const instance = new Swiper(swiperEl, options);
				// almacenar instancia para posibles manipulaciones futuras
				el._multimediaSwiper = instance;
			} catch (err) {
				// eslint-disable-next-line no-console
				console.error('Error inicializando Swiper en módulo multimedia:', err);
			}
		};

		// Intentar inicializar; si Swiper no está aún cargado, reintentar varias veces
		const tryInit = (retriesLeft = 5, delay = 300) => {
			if (typeof Swiper === 'undefined') {
				if (retriesLeft <= 0) {
					// eslint-disable-next-line no-console
					console.warn('Swiper no está disponible después de varios intentos.');
					return;
				}
				setTimeout(() => tryInit(retriesLeft - 1, delay), delay);
				return;
			}

			_doInit();
		};

		tryInit();
	}
}